"use client";

import { COOKIE_SETTINGS_EVENT } from "@/components/cookieConsent";
import { cn } from "@/lib/utils";

export function CookieSettingsLink({
  className,
  children = "Cookie settings",
}: {
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT))}
      className={cn("cursor-pointer", className)}
    >
      {children}
    </button>
  );
}
